// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"51":"df81cd48","113":"e37d1161","304":"d651416a","380":"21c99bce","393":"5a77463c","411":"ed9a70e8","481":"57e70e5b","507":"5feb35d2","566":"8b0b7bf0","814":"be3dae7e","906":"2226062f","920":"41973ee6","960":"1f641c8e"}[chunkId] + ".js";
};